import styled from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia, styledTypography } from '@pkg/primitives';

export const Action = styled(CommonAction)`
    ${recipesCommonAction.basic};
    gap: 8px;
    padding-left: 16px;
    padding-right: 16px;
    min-width: 140px;
    height: 40px;
    background-color: rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgba(255, 255, 255, 0.16);
    }
`;

export const Label = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const IconWrapper = styled.span`
    ${styledMedia.iconWrapper};
    width: 16px;
    height: 16px;
`;
